// extracted by mini-css-extract-plugin
export default {"container":"CoursePage_container__cbP4o","content":"CoursePage_content__cl5Vd"};